module.exports = __webpack_public_path__ + "img/Discover.1e714425.webp";